<script>
import Component from '~/sites/oknanebodvere/pages/faq/index'
export default {
  extends: Component,
  nuxtI18n: {
    paths: {
      cs: '/nejcastejsi-dotazy',
      de: '/faq',
      en: '/faq',
      sk: '/najcastejsie-otazky',
    },
  },
}
</script>
